import { Injectable, signal } from '@angular/core';

export type UiToastType = 'success' | 'error' | 'warning' | 'info';

export interface UiToastItem {
  id: string;
  message: string;
  type: UiToastType;
  dismissible?: boolean;
  durationMs?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly items = signal<UiToastItem[]>([]);

  show(options: Omit<UiToastItem, 'id'> & { id?: string }): string {
    const id = options.id ?? globalThis.crypto?.randomUUID?.() ?? `toast-${Date.now()}`;
    const item: UiToastItem = {
      id,
      message: options.message,
      type: options.type,
      dismissible: options.dismissible ?? true,
      durationMs: options.durationMs ?? 5000,
    };
    this.items.update((list) => [...list, item]);
    if (item.durationMs && item.durationMs > 0) {
      window.setTimeout(() => this.dismiss(id), item.durationMs);
    }
    return id;
  }

  dismiss(id: string): void {
    this.items.update((list) => list.filter((t) => t.id !== id));
  }

  clear(): void {
    this.items.set([]);
  }
}
